import vSlider from "./v-slider.vue";
import vSlide from "./v-slide.vue";

export default Vue => {
  Vue.component("v-slider", vSlider);
  Vue.component("v-slide", vSlide);
};
